import axios, { baseUrl, mobClientId } from './axios';

export default {
  login: async ({
    username,
    password,
    rememberMe = false,
    clientId = parseInt(mobClientId),
  }) => {
    const result = await axios.post(`${baseUrl}/account/pub/mob/user/logins`, {
      username,
      password,
      rememberMe,
      clientId,
    });
    return result.data;
  },
  resetPassword: async ({ username }) => {
    const result = await axios.post(`${baseUrl}/account/user/reset-password`, {
      username,
    });
    return result.data;
  },

  forgotPassword: async ({
    username,
    email,
    clientId = parseInt(mobClientId),
  }) => {
    const result = await axios.post(
      `${baseUrl}/account/pub/user/forgot_passwords`,
      {
        username,
        email,
        clientId,
      },
    );
    return result.data;
  },

  verifyCode: async ({ code, clientId = parseInt(mobClientId) }) => {
    const result = await axios.post(
      `${baseUrl}/account/pub/user/verify_code_reset_passwords`,
      {
        code,
        clientId,
      },
    );
    return result.data;
  },

  changePassword: async ({ username, newPassword, staffId }) => {
    const result = await axios.post(
      `${baseUrl}/account/user/staffs/${staffId}/reset_passwords`,
      {
        username,
        newPassword,
      },
    );
    return result.data;
  },
};
